<template>
  <div>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%">
        <el-table-column
          fixed
          prop="chargeTime"
          label="充值日期"
          width="180">
        </el-table-column>
        <el-table-column
          prop="chargeSource"
          label="充值渠道"
          width="180">
          <div slot-scope="{row}">
            {{ row.chargeSource==='1'?'线下办理':'微信公众号' }}
          </div>
        </el-table-column>
        <el-table-column
          prop="chargeType"
          label="充值类型"
          width="180">
          <div slot-scope="{row}">
            {{ row.chargeType==='1'?'会员充值':'会员充次' }}
          </div>
        </el-table-column>
        <el-table-column
          prop="chargeContent"
          label="充值内容"
          width="200">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额/次数"
          width="150">
          <div slot-scope="{row}">
            {{ row.chargeType==='1'? row.price:row.chargeNum }}
          </div>
        </el-table-column>
        <el-table-column
          prop="chargeUser"
          label="操作人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="chargeRemark"
          label="备注">
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {member} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'LogServe',
  props: {
    memberId: String
  },
  mounted () {
    this.getTableData()
  },
  data () {
    return {
      loading: false,
      page: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: []
    }
  },
  methods: {
    async getTableData () {
      this.loading = true
      let {data, page} = await member.pageMemberRechargeLogDetail({
        page: this.page,
        param: {
          orgCode: getSession(ORG_CODE),
          memberId: this.memberId
        }
      })
      this.page = page
      this.loading = false
      this.tableData = data
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
